/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import contentBoxHeadStyle from "./contentBoxHeadStyle";
import Typography from "@mui/material/Typography";
import { Box, Theme } from "@mui/material";
import { SxProps } from "@mui/system";

type ContentBoxHeadProps = {
  Icon?: React.ComponentType<{ sx?: SxProps<Theme> }>;
  altText?: string;
  headline: string;
};

const ContentBoxHead = ({ Icon, headline }: ContentBoxHeadProps) => {
  return (
    <Box sx={contentBoxHeadStyle.contentBoxHeader}>
      <Box sx={contentBoxHeadStyle.imageContainer}>{Icon && <Icon sx={contentBoxHeadStyle.headerIcon} />}</Box>
      <Typography variant={"h5"} component={"h3"} sx={contentBoxHeadStyle.headerTitleContainer}>
        {headline}
      </Typography>
    </Box>
  );
};

export default ContentBoxHead;
